import { render, staticRenderFns } from "./items-config-diff.vue?vue&type=template&id=3432f8a7"
import script from "./items-config-diff.vue?vue&type=script&lang=js"
export * from "./items-config-diff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports